/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import 'brace/ext/language_tools';
import 'brace/mode/json';
import 'brace/theme/github';
import gatewayFieldsetTemplate from './gateway-fieldset.tpl.html';
import gatewayInfoDialogTemplate from './gateway-info/gateway-info.dialog.tpl.html';
import './gateway.scss';

/*@ngInject*/
export default function GatewayDirective($rootScope, $timeout, $compile, $templateCache, $translate, $window, $mdUtil, $filter, $mdMedia, $mdDialog,
                                         $document, types, gatewayService, gatewayModelService, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayFieldsetTemplate);
        element.html(template);

        scope.types = types;

        scope.statsQuery = {
            order: '-ts',
            limit: 15,
            page: 1,
            search: null
        };

        scope.statsLimitOptions = [15, 30, 45];

        scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
            scope.isGtMd = isGtMd;
            if (scope.isGtMd) {
                scope.statsLimitOptions = [15, 30, 45];
            } else {
                scope.statsLimitOptions = null;
            }
        });

        scope.$watch('gateway.id.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    reset();
                    updateGatewayLocation();
                    createGatewaySubscriptions();
                }
            }
        });

        scope.$watch('gateway.gatewayModelId', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                loadGatewayFrequencyInfo();
            }
        });

        scope.onGatewayIdCopied = function() {
            toast.showSuccess($translate.instant('gateway.id-copied-message'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.triggerResize = function() {
            $timeout(() => {
                var w = angular.element($window);
                w.triggerHandler('resize');
                $window.dispatchEvent(new Event("resize")); //eslint-disable-line
            }, 100);
        };

        scope.$watch("statsQuery.search", function(newVal, prevVal) {
            if (!angular.equals(newVal, prevVal) && scope.statsQuery.search != null) {
                updateGatewayStatsRows();
            }
        });

        scope.enterGatewayStatisticsFilterMode = function () {
            scope.statsQuery.search = '';
        };

        scope.exitGatewayStatisticsFilterMode = function () {
            scope.statsQuery.search = null;
            updateGatewayStatsRows();
        };

        scope.onGatewayStatisticsReorder = function () {
            updateGatewayStatsRows();
        };

        scope.onGatewayStatisticsPaginate = function () {
            updateGatewayStatsRows();
        };

        scope.openGatewayInfo = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'GatewayInfoController',
                controllerAs: 'vm',
                templateUrl: gatewayInfoDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.toggleGatewayState = function() {
            var promise = scope.gateway.disabled ? gatewayService.enableGateway(scope.gateway.id.id)
                : gatewayService.disableGateway(scope.gateway.id.id);
            promise.then(
                () => {
                    scope.gateway.disabled = !scope.gateway.disabled;
                    updateGatewayStateParameters();
                    $rootScope.$broadcast('reloadEntityDetails');
                    $rootScope.$broadcast('entityUpdated', scope.gateway);
                }
            );
        };

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (scope.isEdit && scope.selectedTab > 1) {
                    scope.selectedTab = 0;
                }
                updateGatewayLocation();
            }
        });

        scope.$on("$destroy", function () {
            reset();
        });

        function loadGatewayFrequencyInfo() {
            scope.gatewayFrequencyBandInfo = null;
            if (scope.gateway.gatewayModelId) {
                gatewayModelService.getGatewayModel(scope.gateway.gatewayModelId.id).then(
                    (gatewayModel) => {
                        scope.gatewayFrequencyBandInfo = types.gatewayFrequency[gatewayModel.gatewayFrequency].info;
                        scope.gatewayModelChannels = gatewayModel.additionalInfo ? gatewayModel.additionalInfo.channels : '';
                    }
                );
            }
        }

        function updateGatewayStateParameters() {
            scope.onlineStatus = $translate.instant(scope.gateway.disabled  ? 'gateway.disabled' : 'gateway.enabled');
            scope.onlineStatusColor = scope.gateway.disabled ? '#ff0000' : '#1a901a';
        }

        function reset() {
            scope.gatewayState = {};
            scope.gatewayStats = [];

            if (scope.gatewayStateSubscriptionHandle) {
                scope.gatewayStateSubscriptionHandle();
                scope.gatewayStateSubscriptionHandle = null;
            }
            if (scope.gatewayStatsSubscriptionHandle) {
                scope.gatewayStatsSubscriptionHandle();
                scope.gatewayStatsSubscriptionHandle = null;
            }

            scope.lastActivityTime = null;

            updateGatewayStateParameters();

            scope.currentGatewayLat = null;
            scope.currentGatewayLng = null;
            scope.currentGatewayAlt = null;

            scope.statsQuery.order = '-ts';
            scope.statsQuery.limit = 15;
            scope.statsQuery.page = 1;
            scope.statsQuery.search = null;

            scope.currentGatewayCenter = {
                lat: 0,
                lng: 0,
            };

            scope.marker = {};
        }

        function createGatewaySubscriptions() {
            scope.gatewayStateSubscriptionHandle = gatewayService.subscribeForGatewayStateData(scope.gateway.id.id,
                onGatewayStateData);
            scope.gatewayStatsSubscriptionHandle = gatewayService.subscribeForGatewayStatsData(scope.gateway.id.id,
                onGatewayStatsData, onGatewayStatsDataReconnected);
        }

        function onGatewayStatsData(gatewayStats) {
            scope.$apply(() => {
                if (gatewayStats && gatewayStats.length) {
                    scope.gatewayStats = scope.gatewayStats.concat(convertGatewayStats(gatewayStats));
                }
                if (scope.gatewayStats.length) {
                    scope.gatewayStats.sort(function(stat1, stat2) {
                        return gatewayStatsTsComparator(stat1, stat2, true);
                    });
                }
                updateGatewayStatsRows();
            });
        }

        function onGatewayStatsDataReconnected() {
            scope.$apply(() => {
                scope.gatewayStats = [];
                updateGatewayStatsRows();
            });
        }

        function gatewayStatsTsComparator(stat1, stat2, reverse) {
            var ts = stat1.ts - stat2.ts;
            if (ts < 0) {
                return reverse ? 1 : -1;
            } else if (ts > 0) {
                return reverse ? -1 : 1;
            } else {
                if (isUplink(stat1) && isDownlink(stat2)) {
                    return reverse ? 1 : -1;
                } else if (isDownlink(stat1) && isUplink(stat2)) {
                    return reverse ? -1 : 1;
                } else {
                    return 0;
                }
            }
        }

        function convertGatewayStats(gatewayStats) {
            for (var i=0;i<gatewayStats.length;i++) {
                var row = gatewayStats[i];
                if (isJoin(row)) {
                    row.fcntDown = null;
                    row.fcntUp = null;
                }
                if (isUplink(row)) {
                    row.fcntDown = null;
                } else if (isDownlink(row)) {
                    row.fcntUp = null;
                    row.rssi = null;
                    row.loRaSNR = null;
                }
            }
            return gatewayStats;
        }

        function isJoin(stat) {
            return stat.messageType == 'Join Request' || stat.messageType == 'Join Accept';
        }

        function isDownlink(stat) {
            return stat.messageType == 'Downlink' || stat.messageType == 'Join Accept';
        }

        function isUplink(stat) {
            return stat.messageType == 'Uplink' || stat.messageType == 'Join Request';
        }

        function onGatewayStateData(gatewayState) {
            scope.$apply(() => {
                scope.gatewayState = gatewayState;
                if (scope.gatewayState.lastActivityTime) {
                    scope.lastActivityTime = $filter('date')(scope.gatewayState.lastActivityTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastActivityTime = null;
                }
                updateGatewayStateParameters();
            });
        }

        function updateGatewayStatsRows() {
            var result;
            if (scope.statsQuery.order == 'ts' || scope.statsQuery.order == '-ts') {
                result = scope.gatewayStats.sort(function(stat1, stat2) {
                    return gatewayStatsTsComparator(stat1, stat2, scope.statsQuery.order == '-ts');
                });
            } else {
                result = $filter('orderBy')(scope.gatewayStats, scope.statsQuery.order);
            }
            if (scope.statsQuery.search != null) {
                result = $filter('filter')(result, {$: scope.statsQuery.search});
            }
            scope.statsRowsCount = result.length;
            var startIndex = scope.statsQuery.limit * (scope.statsQuery.page - 1);
            scope.gatewayStatsRows = result.slice(startIndex, startIndex + scope.statsQuery.limit);
        }

        function updateGatewayLocation() {
            const lat = scope.gateway.lat;
            const lng = scope.gateway.lng;
            const altitude = scope.gateway.altitude;

            scope.currentGatewayLat = lat;
            scope.currentGatewayLng = lng;
            scope.currentGatewayAlt = altitude;
            if (scope.currentGatewayLat != null && scope.currentGatewayLng != null) {
                scope.markers = [{
                    name: scope.gateway.name,
                    lat: scope.currentGatewayLat,
                    lng: scope.currentGatewayLng,
                    alt: scope.currentGatewayAlt
                }];
            } else {
                scope.markers = [];
            }
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            gateway: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway/gateway.directive.js